import { useAxios } from '../context/AxiosContext';
import { format } from 'date-fns';
import { downloadFileFromResponse } from '../utils/fileDownload';
import { toast } from 'react-toastify';

export const useDownloadActivities = (params: any) => {
  const { authAxios } = useAxios();
  return () =>
    authAxios
      .get('/audit/download/activities-by-params', {
        params,
        responseType: 'blob'
      })
      .then((response) => downloadFileFromResponse(response, `Activity Log ${format(new Date(), 'MM-dd-yyyy')}.csv`))
      .catch((error) => {
        if (error.response.status === 413)
          toast.error('Too many results. Please try to adjust your search criteria.', { position: 'top-center' });
      });
};
